import styled from "styled-components";
import { Button } from "antd";

export const StyledButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: none;
  gap: 4px;
  width: fit-content;

  height: ${({ theme, $variant }) =>
    $variant === "secondary" ? "auto" : theme?.buttons.withIcon?.height};
  font-weight: ${({ $variant }) => ($variant === "secondary" ? "550" : "500")};
  font-size: ${({ theme, $variant }) =>
    $variant === "secondary" ? "12px" : theme?.buttons.withIcon?.fontSize};
  padding: ${({ theme, $variant }) =>
    $variant === "secondary" ? "6px 16px" : theme?.buttons.withIcon?.padding};
  font-style: ${({ $variant }) =>
    $variant === "secondary" ? "normal" : "inherit"};
  text-transform: ${({ $variant }) =>
    $variant === "secondary" ? "capitalize" : "inherit"};

  background-color: ${({ theme, $variant }) => {
    switch ($variant) {
      case "blue":
        return theme?.pallette?.blue?.link;
      case "green":
        return theme?.pallette?.green?.main;
      case "secondary":
        return theme?.buttons?.secondary?.background ?? "#ffffff";
      default:
        return theme?.buttons.withIcon?.background;
    }
  }};
  border-radius: ${({ theme, $variant }) =>
    $variant === "secondary" ? "8px" : theme?.buttons.withIcon?.radius};
  line-height: ${({ theme, $variant }) =>
    $variant === "secondary" ? "16px" : theme?.buttons.withIcon?.lineHeight};
  box-shadow: ${({ theme, $variant }) =>
    $variant === "secondary"
      ? theme?.buttons?.secondary?.shadow
      : theme?.buttons?.withIcon?.shadow};
  color: ${({ theme, $variant }) => {
    switch ($variant) {
      case "blue":
      case "green":
        return theme?.pallette?.white?.primary;
      case "secondary":
        return theme?.buttons?.secondary?.color ?? "#303030";
      default:
        return theme?.buttons?.withIcon?.color;
    }
  }};
  border: ${({ theme, $variant }) => {
    switch ($variant) {
      case "secondary":
        return "1px solid transparent";
      case "blue":
        return `1px solid ${theme?.pallette?.blue?.link}`;
      case "green":
        return "none";
      default:
        return theme?.buttons?.withIcon?.border;
    }
  }};

  svg {
    width: ${({ $iconSize }) => $iconSize ?? "14px"};
    height: ${({ $iconSize }) => $iconSize ?? "14px"};
    color: inherit;
  }

  svg path {
    stroke: ${({ $variant, theme }) => {
      switch ($variant) {
        case "blue":
        case "green":
          return theme?.pallette?.white?.primary;
        case "secondary":
          return theme?.buttons?.secondary?.color;
        default:
          return theme?.buttons.withIcon?.color;
      }
    }};
  }

  span {
    margin-inline-start: 0 !important;
  }

  &:not(:disabled):hover,
  &:not(:disabled):focus {
    background-color: ${({ theme, $variant }) => {
      switch ($variant) {
        case "blue":
          return theme?.pallette?.white?.main;
        case "green":
          return theme?.pallette?.green?.dark || theme?.pallette?.green?.main;
        case "secondary":
          return theme?.buttons?.secondary?.hover?.background ?? "#FAFAFA";
        default:
          return theme?.buttons.withIcon?.hover?.background;
      }
    }};
    box-shadow: ${({ theme, $variant }) =>
      $variant === "secondary"
        ? theme?.buttons?.secondary?.shadow
        : theme?.buttons?.withIcon?.shadow};

    border: ${({ theme, $variant }) => {
      switch ($variant) {
        case "blue":
          return `1px solid ${theme?.pallette?.blue?.link}`;
        case "green":
        case "secondary":
          return "1px solid transparent";
        default:
          return "none";
      }
    }} !important;

    svg path {
      stroke: ${({ $variant, theme }) => {
        switch ($variant) {
          case "blue":
            return theme?.pallette?.blue?.link;
          case "green":
            return theme?.pallette?.blue?.primary;
          case "secondary":
            return theme?.pallette?.blue?.primary;
          default:
            return theme?.pallette?.white?.main;
        }
      }};
    }

    span {
      color: ${({ theme, $variant }) => {
        switch ($variant) {
          case "blue":
            return theme?.pallette?.blue?.link;
          case "green":
            return theme?.pallette?.blue?.primary;
          case "secondary":
            return theme?.pallette?.blue?.primary;
          default:
            return theme?.pallette?.white?.main;
        }
      }};
    }
  }

  span {
    color: ${({ theme, $variant, $isShopify }) => {
      switch ($variant) {
        case "blue":
        case "green":
          return theme?.pallette?.white?.primary;
        case "secondary":
          return theme?.buttons?.secondary?.hover?.color;
        default:
          return $isShopify
            ? theme?.pallette?.white?.main
            : theme?.pallette?.blue?.primary;
      }
    }};
  }

  svg path {
    stroke: ${({ theme, $variant, $isShopify }) => {
      switch ($variant) {
        case "blue":
          return theme?.pallette?.white?.primary;
        case "green":
        case "secondary":
          return theme?.buttons?.secondary?.hover?.color;
        default:
          return $isShopify
            ? theme?.pallette?.white?.main
            : theme?.pallette?.blue?.primary;
      }
    }};
  }

  &:disabled {
    opacity: 0.5;
  }

  svg:last-child:hover {
    g {
      opacity: 1;
    }
  }
`;
